/* eslint-disable */
import './Login.scss';
import { SYSTEMS_ROUTE, DESCARGAS_PORTAL_ROUTE } from 'constants/routeNames';
import logoHeader from 'assets/images/Logo_SIMAC_Mix_.svg';
import logoFooter from 'assets/images/Logo_INE.png';
import { Button, Form, Input, Select, Spin, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAutenticacionState,
  selectCaptchaState,
  selectEstadosState,
  selectIndicadoresState
} from 'selectors/autenticacion.selector';
import { useEffect, useState } from 'react';
import {
  getCaptchaAutenticacion,
  getEstadosAutenticacion,
  getIndicadoresAutenticacion,
  getTokenAutenticacion
} from 'actions/autenticacion.actions';
import { useNavigate } from 'react-router-dom';
import { generateCaptcha } from 'utils/generateCaptcha';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import InfoModal from 'components/InfoModal/Autenticacion/InfoModal';
import simacLogo from '../../assets/images/Login/Logo_SIMAC_.svg';
import loginTexto from '../../assets/images/LoginV2/Login_Texto_.svg';
import enlaceExterno from '../../assets/images/Login/enlace_externo.svg';
import loginInfo from '../../assets/images/LoginV2/Login_imagen.svg';
import loginEsp from '../../assets/images/Login/Login_Esp.svg';
import loginInternet from '../../assets/images/Login/Login_Internet.svg';
import loginMediosImp from '../../assets/images/Login/Login_MI.svg';
import loginEventos from '../../assets/images/Login/Login_eventos.svg';

const { Text } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [ipAddress, setIPAdress] = useState(null);
  const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
  const [visibleErrorModal, setVisibleErrorModal] = useState(false);
  const [visibleMessageError, setVisibleMessageError] = useState(false);
  const [messageErrorModal, setMessageErrorModal] = useState('');
  const [ultimaActualizacion, setUltimaActualizacion] = useState('');
  const [indicadorViaPublica, setIndicadorViaPublica] = useState('');
  const [indicadorInternet, setIndicadorInternet] = useState('');
  const [indicadorMediosImpresos, setIndicadorMediosImpresos] = useState('');
  const [indicadorEventos, setIndicadorEventos] = useState('');
  const [indicadorCasas, setIndicadorCasas] = useState('');

  const { loading: loadingEdos, data: optionsEdos } = useSelector(selectEstadosState);
  const { loading: loadingIndicadores } = useSelector(selectIndicadoresState);
  const { data: activeCaptcha } = useSelector(selectCaptchaState);
  const { loading: loadingToken } = useSelector(selectAutenticacionState);

  // const loginSize = activeCaptcha ? { '--hg-size': '55vh' } : { '--hg-size': '45vh' };

  const getAccesSistem = async (values) => {
    try {
      const { usuario, password, captcha } = values;
      const dataAccessUser = {
        usuario,
        password,
        ipAddress,
        captcha
      };
      const { success, response } = await dispatch(getTokenAutenticacion(dataAccessUser));
      if (success) {
        form.resetFields();
        document.cookie = `JWT-TOKEN-SIMAC=${response.token || ''}`;
        navigate(SYSTEMS_ROUTE);
      }
      if (!success) {
        form.resetFields();
        if (response.error.code === 500) {
          setVisibleMessageError(true);
          setMessageErrorModal(response.error.message);
          setGeneratedCaptcha(generateCaptcha());
        }
        setVisibleErrorModal(true);
        setGeneratedCaptcha(generateCaptcha());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getIndicadoresEstado = async (estadoId) => {
    try {
      const { success, response } = await dispatch(getIndicadoresAutenticacion(estadoId));
      if (success) {
        setUltimaActualizacion(response.ultimaFecha);
        setIndicadorViaPublica(response.indicadores[0]?.resumen.total);
        setIndicadorMediosImpresos(response.indicadores[1]?.resumen.total);
        setIndicadorInternet(response.indicadores[2]?.resumen.total);
        setIndicadorEventos(response.indicadores[3]?.resumen.total);
        setIndicadorCasas(response.indicadores[4]?.resumen.total);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateCaptcha = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Código requerido.'));
    }
    if (value.length < 6) {
      return Promise.reject(new Error('Código incompleto.'));
    }
    if (value.length === 6 && value !== generatedCaptcha) {
      setGeneratedCaptcha(generateCaptcha());
      return Promise.reject(new Error('Código erroneo.'));
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIPAdress(data.ip);
      } catch (error) {
        console.error('Error obteniendo la IP:', error);
        setIPAdress(null);
      }
    };
    fetchIP();
    dispatch(getEstadosAutenticacion());
    dispatch(getCaptchaAutenticacion());
  }, []);

  return (
    <>
      <InfoModal
        visible={visibleErrorModal}
        message={messageErrorModal}
        visibleMessage={visibleMessageError}
        onClose={() => {
          setVisibleErrorModal(false);
          setVisibleMessageError(false);
        }}
      />
      <header className="headerLogin">
        <img src={logoHeader} alt="logoHeaderLogin" style={{ width: 100, height: 90 }} />
      </header>
      <main className="mainLoginAuth">
        <div className="container">
          <nav className="nav">
            <a href={DESCARGAS_PORTAL_ROUTE} className="nav__item">
              <img
                src={enlaceExterno}
                alt="enlace externo"
                style={{ height: '25px', width: '25px', paddingRight: '10px' }}
              />
              Portal descargas
            </a>
          </nav>

          <section className="login__container">
            <div className="login__indicadores">
              <img
                className="login__indicadores__imgTexto"
                src={loginTexto}
                alt="img-login-texto"
              />

              <div className="login__indicadores__selectDatos">
                {
                  /*
                  <Text className="label-Text">Entidad:</Text>
                  <Select
                    name="idEstado"
                    className="selectEntidades"
                    placeholder="Selecciona"
                    fieldNames={{
                      value: 'idEstado',
                      label: 'nombreEstado'
                    }}
                    options={optionsEdos}
                    filterOption={(inputValue, option) =>
                      option.nombreEstado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onChange={(e) => getIndicadoresEstado(e)}
                    loading={loadingEdos}
                    showSearch
                  />
                  <Text className="labelText">
                    Última actualización: <Text className="fechaText">{ultimaActualizacion}</Text>
                  </Text>
                  */
                }
              </div>

              <div className="login_indicadores__plataformas">
                <div className="card__monitoreos">
                  <div className="card__monitoreos__section">
                    <Text className="tituloMonitoreo">Monitoreos</Text>
                  </div>
                  <div className="card__monitoreos__section grid-section">
                    <div className="sub-section">
                      <img className="imgMonitoreos" src={loginEsp} alt="img-espectaculares" />
                    </div>
                    <div className="sub-section column-section">
                      <Text className="monitoreo">Vía pública</Text>
                      {loadingIndicadores ? (
                        <Spin className="spinLoader" size="small" />
                      ) : (
                        <Text className="dato">{indicadorViaPublica}</Text>
                      )}
                    </div>
                  </div>
                  <div className="card__monitoreos__section grid-section">
                    <div className="sub-section">
                      <img className="imgMonitoreos" src={loginInternet} alt="img-internet" />
                    </div>
                    <div className="sub-section column-section">
                      <Text className="monitoreo">Internet</Text>
                      {loadingIndicadores ? (
                        <Spin size="small" />
                      ) : (
                        <Text className="dato">{indicadorInternet}</Text>
                      )}
                    </div>
                  </div>
                  <div className="card__monitoreos__section grid-section">
                    <div className="sub-section">
                      <img
                        className="imgMonitoreos"
                        src={loginMediosImp}
                        alt="img-mediosImpresos"
                      />
                    </div>
                    <div className="sub-section column-section">
                      <Text className="monitoreo">Medios impresos</Text>
                      {loadingIndicadores ? (
                        <Spin size="small" />
                      ) : (
                        <Text className="dato">{indicadorMediosImpresos}</Text>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card__visitas">
                  <div className="card__visitas__section">
                    <Text className="tituloVisitas">Visitas de verificación</Text>
                  </div>
                  <div className="sectionVisitas grid-section">
                    <div className="sub-section">
                      <img className="imgVisitas" src={loginEventos} alt="img-eventos" />
                    </div>
                    <div className="sub-section column-section">
                      <Text className="visita">
                        Eventos de Apoyo ciudadano, Precampaña o Campaña
                      </Text>
                      {loadingIndicadores ? (
                        <Spin size="small" />
                      ) : (
                        <Text className="dato">{indicadorEventos}</Text>
                      )}
                    </div>
                  </div>
                  <div className="sectionVisitas grid-section">
                    <div className="sub-section">
                      <img className="imgVisitas" src={loginEsp} alt="img-casas" />
                    </div>
                    <div className="sub-section column-section">
                      <Text className="visita">Casas de Apoyo ciudadano, Precampaña o Campaña</Text>
                      {loadingIndicadores ? (
                        <Spin size="small" />
                      ) : (
                        <Text className="dato">{indicadorCasas}</Text>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="login__formulario">
              <Form form={form} layout="vertical" autoComplete="off" onFinish={getAccesSistem}>
                <div className="login__formulario__container">
                  <div className="login__formulario__imgLogo">
                    <img className="logo-simacLogin" src={simacLogo} alt="simac-logo" />
                  </div>
                  <Form.Item
                    name="usuario"
                    rules={[{ required: true, message: 'El usuario es requerido' }]}>
                    <Input
                      maxLength={50}
                      className="inputs"
                      placeholder="Usuario"
                      prefix={<UserOutlined style={{ color: '#D5007F' }} />}
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'La contraseña es requerida' }]}>
                    <Input.Password
                      maxLength={50}
                      className="inputs"
                      placeholder="Contraseña"
                      prefix={<LockOutlined style={{ color: '#D5007F' }} />}
                    />
                  </Form.Item>
                  {activeCaptcha ? (
                    <div className="generadorCaptcha">
                      <Text delete strong className="textCaptcha">
                        {generatedCaptcha}
                      </Text>
                      <Form.Item
                        className="inputItemCaptcha"
                        name="captcha"
                        rules={[{ validator: validateCaptcha }]}>
                        <Input
                          maxLength={6}
                          placeholder="Ingresa el código"
                          className="inputCaptcha"
                        />
                      </Form.Item>
                    </div>
                  ) : (
                    <> </>
                  )}
                  <Button
                    className="btnForm"
                    type="primary"
                    htmlType="submit"
                    loading={loadingToken}>
                    Inicio de sesión
                  </Button>
                </div>
              </Form>
            </div>
          </section>
        </div>
        <div className="mainLoginAuth__info">
          <img className="imgInfo" src={loginInfo} alt="img-login-info" />
        </div>
      </main>
      <footer>
        <div className="containerFooter">
          <img src={logoFooter} className="imgFooter" alt="LogoFooterINE" />
          <nav className="nav nav--footer">
            <a href="https://cau.ine.mx/" className="nav__item nav__item--footer">
              CAU
            </a>
          </nav>
          <Text className="textFooter">
            | Compatibilidad óptima con Google Chrome | © Derechos Reservados, Instituto Nacional
            Electoral, México 1991 al 2024
          </Text>
          <Text className="revFooter">{`SIMAC 1.0.0 REV ${process.env.REACT_APP_VERSION}`}</Text>
        </div>
      </footer>
    </>
  );
};

export default Login;
